export const formatCurrency = (value: string | number): string => {
  if (!value) return '';

  const numValue =
    typeof value === 'string' ? parseFloat(value.replace(/,/g, '')) : value;
  if (Number.isNaN(numValue)) return '';

  return numValue.toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

export const unformatCurrency = (value: string): string => {
  if (!value) return '';
  return value.replace(/,/g, '');
};
